export default "__VITE_ASSET__DvMg$if___"